/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2022-10-11 11:39:10
 *
 *******************************************************/
// @flow

import _ from 'lodash';
import React, { Component } from 'react';
import { getShop } from 'src/helpers';
import { Checkbox, Link, Stack, Thumbnail } from '@shopify/polaris';

import noProductImage from 'src/assets/images/product/no-product-image.png';
import { optimizeImage } from 'src/helpers';

type Props = {
  item: Object,
  index: number,
  onSelect: Function,
  isFull?: boolean
};
// DONE
class OptionItem extends Component<Props> {
  render() {
    const { item, index, onSelect, isFull } = this.props;
    const shop = getShop();
    const url = `https://${shop}/admin/products/${item.id}`;
    const { images } = item;
    let image = _.isEmpty(images)
      ? noProductImage
      : optimizeImage(images[Object.keys(images)[0]], '40x40');

    return (
      <React.Fragment>
        <li className="BC-ProductItem">
          <Stack alignment="center" spacing="tight">
            {/* Selected */}
            <div className="BC-ProductItem__Checkbox">
              <Checkbox
                checked={item.isSelected}
                onChange={() => onSelect(index)}
                disabled={isFull && !item.isSelected}
              />
            </div>

            {/* Product Image */}
            <div className={`product-image ${_.isEmpty(images) ? 'no-image' : ''}`}>
              <Thumbnail source={image} size="small" />
            </div>

            {/* Product title */}
            <div>
              <Link removeUnderline external url={url}>
                {item.title}
              </Link>
            </div>
          </Stack>
        </li>
      </React.Fragment>
    );
  }
}

OptionItem.defaultProps = {
  isFull: false
};

export default OptionItem;
